import type { ChapterStatus } from "@/lib/db/schema";

/**
 * A story only "shows up publicly" — i.e. appears in browse, discover, and
 * search — when BOTH the story-level `published` flag is on AND its visibility
 * is `"public"`. This mirrors `publicStoryConditions()` in story-actions.ts.
 */
export function isStoryPubliclyVisible(
    published: boolean,
    visibility: "public" | "private"
): boolean {
    return published && visibility === "public";
}

/**
 * Whether to nudge the author to publish the story after they publish a
 * chapter. Publishing a single chapter does nothing reader-facing while the
 * story itself is still private/unpublished, so we surface a one-time prompt.
 * Never fires inside the `/try` demo (which has no real story to publish).
 */
export function shouldPromptStoryPublish(opts: {
    nextStatus: ChapterStatus;
    storyIsPublic: boolean;
    isDemo: boolean;
}): boolean {
    return (
        opts.nextStatus === "published" &&
        !opts.storyIsPublic &&
        !opts.isDemo
    );
}
